export const REFER_CLIENT_REQUEST_START: string = 'refer/client/REQUEST_START';
export const REFER_CLIENT_REQUEST_FAIL: string = 'refer/client/REQUEST_FAIL';
export const REFER_CLIENT_REQUEST_SUCCESS: string = 'refer/client/REQUEST_SUCCESS';

export const REFER_AFFILIATE_REQUEST_START: string = 'refer/affiliate/REQUEST_START';
export const REFER_AFFILIATE_REQUEST_FAIL: string = 'refer/affiliate/REQUEST_FAIL';
export const REFER_AFFILIATE_REQUEST_SUCCESS: string = 'refer/affiliate/REQUEST_SUCCESS';

export const ETV_OPTION_REQUEST_START: string = 'etv/option/REQUEST_START';
export const ETV_OPTION_REQUEST_FAIL: string = 'etv/option/REQUEST_FAIL';
export const ETV_OPTION_REQUEST_SUCCESS: string = 'etv/option/REQUEST_SUCCESS';